<section class="banner">
  <img
    class="banner__img"
    [src]="banner.url"
    [alt]="banner.alt"
    [width]="banner.width"
    [height]="banner.height"
  />
</section>
